"use client";

import React, {useState} from "react";
import clsx from "clsx";
import {formActionButtonClassNames} from "@/components/forms/SubmitButton";

export function CopyToClipboardIcon(
    {
        content,
        clipboard,
        tooltip,
        ariaLabel,
        classNames,
        wrapperClassNames,
        disabled,
        formAction,
        onCopySuccess,
        onCopyError,
    }: {
        content: React.ReactNode;
        clipboard: string | (() => string);
        tooltip?: string;
        ariaLabel?: string;
        classNames?: string;
        wrapperClassNames?: string;
        disabled?: boolean;
        formAction?: boolean;
        onCopySuccess?: () => void;
        onCopyError?: () => void;
    },
) {

    const [showTooltip, setShowTooltip] = useState(false);

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setShowTooltip(true);
            onCopySuccess?.();
            setTimeout(() => {
                setShowTooltip(false);
            }, 1000);
        } catch (err) {
            console.error(err);
            onCopyError?.();
        }
    };

    return (
        <div className={clsx("max-w-full", wrapperClassNames || "relative")}>
            <button
                type="button"
                disabled={disabled}
                aria-disabled={!!disabled}
                aria-label={ariaLabel}
                className={formAction
                    ? formActionButtonClassNames({disabled, className: clsx("max-w-full", classNames)})
                    : clsx("max-w-full", classNames)}
                onClick={() => copyToClipboard(typeof clipboard === "function" ? clipboard() : clipboard)}>
                {content}
            </button>
            {showTooltip && tooltip && (
                <div
                    aria-live="polite"
                    role="status"
                    className={clsx(
                        "absolute z-9999 top-[-40px] left-1/2 transform -translate-x-1/2 px-3 py-1 text-sm text-white bg-grass-500 rounded-sm shadow-lg transition-opacity duration-300 ease-in-out",
                        showTooltip ? "opacity-100 visible" : "opacity-0 invisible"
                    )}>
                    {tooltip}
                </div>
            )}
        </div>
    );
}
